import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../App.css";
import Header from "../components/Header";
import Footer from "../components/footer";
import PackageSection from "../components/PackageSection";
import InfoSection from "../components/InfoSection";
import StepsweFollow from "../components/StepsweFollow";
import data from "../data/Data.json";
import api, { API_ENDPOINTS } from "../config";
import { Helmet } from "react-helmet-async";
import CarouselService from "../components/CarouselService";

const ServicePage = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch service details + related packages
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1️⃣ Fetch current service
        const serviceRes = await api.get(`${API_ENDPOINTS.GET_ALL_SERVICES}/${id}`);
        const currentService = serviceRes.data.service;
        setService(currentService);

        // 2️⃣ Fetch all packages
        const packagesRes = await api.get(API_ENDPOINTS.GET_ALL_PACKAGES);
        const allPackages = packagesRes.data.packages;

        // // 3️⃣ Filter packages for this service
        // const subPackages = allPackages.filter(
        //   (pkg) => pkg.serviceName === currentService.servicename && pkg.subServiceName
        // );
        // const noSubPackages = allPackages.filter(
        //   (pkg) => pkg.serviceName === currentService.servicename && !pkg.subServiceName
        // );
        // 3️⃣ Filter packages for this service
const subPackages = allPackages.filter(
  (pkg) =>
    pkg.service?.name === currentService.servicename && pkg.subServiceName
);
const noSubPackages = allPackages.filter(
  (pkg) =>
    pkg.service?.name === currentService.servicename && !pkg.subServiceName
);


        // 4️⃣ Group packages
        const groupedPackages = [];

        subPackages.forEach((pkg) => {
          const index = groupedPackages.findIndex(
            (g) => g.subServiceName === pkg.subServiceName
          );
          if (index !== -1) {
            groupedPackages[index].packages.push(pkg);
          } else {
            groupedPackages.push({
              subServiceName: pkg.subServiceName,
              packages: [pkg],
            });
          }
        });

        if (noSubPackages.length > 0) {
          groupedPackages.push({
            subServiceName: null,
            packages: noSubPackages,
          });
        }

        setPackages(groupedPackages);
      } catch (err) {
        console.error("Error fetching service data:", err);
        setError("Failed to load service.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchData();
  }, [id]);

  if (loading) return <div className="chaotic-orbit"></div>;
  if (error) return <p>{error}</p>;
  if (!service) return <p>Service not found.</p>;

  // optional static info from Data.json
  const staticInfo = service?.servicename
    ? data[service.servicename.replace(/\s+/g, "")]
    : null;

  return (
    <>
      <Helmet>
        <title>{service.servicename} | Iklim Digitals</title>
        <meta
          name="description"
          content={`Explore ${service?.servicename} services at Iklim Digitals. We help brands grow with modern websites, strategic online campaigns, and engaging content tailored to your business.`}
        />
        <meta
          name="keywords"
          content={`Iklim Digitals, ${service?.servicename}, Web Development, Digital Advertising, Content Production, marketing, branding, Ethiopian marketing, website design, content creation, online campaigns`}
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://iklimdigitals.com/" },
              { "@type": "ListItem", position: 2, name: "Services", item: "https://iklimdigitals.com/services" },
              { "@type": "ListItem", position: 3, name: service?.servicename, item: `https://iklimdigitals.com/services/${id}` },
            ],
          })}
        </script>
      </Helmet>

      <Header />

      <div className="page-namespot">
        <h2 id="page-name">{service.servicename}</h2>
      </div>

      {packages.length === 0 ? (
        <p style={{ textAlign: "center", fontStyle: "italic" }}>No packages available.</p>
      ) : (
        packages.map((group, idx) => (
          <div key={idx}>
            {group.subServiceName && (
              <h3 style={{ textAlign: "center", marginTop: "40px" }}>
                {group.subServiceName}
              </h3>
            )}
            <PackageSection packages={group.packages} />
          </div>
        ))
      )}

      {/* Info Section */}
      <InfoSection data={service} />

      {/* Steps Section */}
      <StepsweFollow />

      {/* Carousel Section */}
      {(service?.carouselRow1?.length > 0 ||
        service?.carouselRow2?.length > 0 ||
        service?.carouselRow3?.length > 0) && (
          <CarouselService
            carouselRow1={service.carouselRow1}
            carouselRow2={service.carouselRow2}
            carouselRow3={service.carouselRow3}
            serviceName={service.servicename}
          />
      )}

      <Footer />
    </>
  );
};

export default ServicePage;
